import { render, staticRenderFns } from "./clearance-checker.vue?vue&type=template&id=1ded88a8&scoped=true"
import script from "./clearance-checker.vue?vue&type=script&lang=js"
export * from "./clearance-checker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ded88a8",
  null
  
)

export default component.exports